import o from "./indexConfig.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const r = i(o);
export {
  r as initConfigurationGoods
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/index.js
// module id = 1224
// module chunks = 41